export class SandboxConsole {
  private container: HTMLElement;
  private originalConsole: {
    log: typeof console.log;
    info: typeof console.info;
    warn: typeof console.warn;
    error: typeof console.error;
  };

  constructor(container: HTMLElement) {
    this.container = container;
    this.originalConsole = {
      log: console.log.bind(console),
      info: console.info.bind(console),
      warn: console.warn.bind(console),
      error: console.error.bind(console),
    };
  }

  captureConsole(): void {
    const self = this;

    console.log = (...args: unknown[]) => {
      self.originalConsole.log(...args);
      self.addLine('info', args);
    };

    console.info = (...args: unknown[]) => {
      self.originalConsole.info(...args);
      self.addLine('info', args);
    };

    console.warn = (...args: unknown[]) => {
      self.originalConsole.warn(...args);
      self.addLine('warn', args);
    };

    console.error = (...args: unknown[]) => {
      self.originalConsole.error(...args);
      self.addLine('error', args);
    };
  }

  private addLine(level: 'info' | 'warn' | 'error', args: unknown[]): void {
    const line = document.createElement('div');
    line.className = `console-line ${level}`;
    line.textContent = this.formatArgs(args);
    this.container.appendChild(line);
    this.container.scrollTop = this.container.scrollHeight;

    // Keep only the last 100 lines
    while (this.container.children.length > 100) {
      this.container.removeChild(this.container.firstChild!);
    }
  }

  private formatArgs(args: unknown[]): string {
    return args
      .map((arg) => {
        if (typeof arg === 'object') {
          try {
            return JSON.stringify(arg, null, 2);
          } catch {
            return String(arg);
          }
        }
        return String(arg);
      })
      .join(' ');
  }

  clear(): void {
    this.container.innerHTML = '';
  }

  restore(): void {
    console.log = this.originalConsole.log;
    console.info = this.originalConsole.info;
    console.warn = this.originalConsole.warn;
    console.error = this.originalConsole.error;
  }
}
